import emailjs from 'emailjs-com';


export const sendBilling = (templateParams) => {
  emailjs.send('service_7dkacsr','template_xqvb3ut', templateParams, 'user_M1hGdI4WU02MeRE8dk9oj')
  .then((response) => {
     console.log('SUCCESS!', response.status, response.text);
  }, (err) => {
     console.log('FAILED...', err);
  });

}